import {TableColumn} from '@fl/cmsch-fe-library';

import {MaleHolsteinAnimalInList} from 'api/gen/MaleHolsteinAnimalInList';

import {
    dateColumn,
    decimalColumn,
    hyperlinkColumn,
    numberColumn,
    stringColumn,
} from '../../../user/utils/table-columns-helpers';
import {getAnimalBrowserLink} from '../../utils';

export const matingHolsteinBullsColumns: Array<TableColumn<MaleHolsteinAnimalInList>> = [
    hyperlinkColumn({
        field: 'lineRegistry',
        width: 130,
        valueToUrl: getAnimalBrowserLink,
        filterTypes: ['containsStringOr', {type: 'multiSelectStringOrEquals', subtype: 'bulkString'}, 'null'],
    }),
    stringColumn({
        field: 'earTag',
        width: 150,
        verticalName: false,
        filterTypes: [
            'betweenEarTags',
            'containsStringOr',
            {type: 'multiSelectStringOrEquals', subtype: 'bulkString'},
            'null',
        ],
    }),
    dateColumn({field: 'birthDate', width: 150}),
    stringColumn({
        field: 'name',
        width: 130,
        filterTypes: ['containsStringOr', {type: 'multiSelectStringOrEquals', subtype: 'bulkString'}, 'null'],
    }),
    stringColumn({
        field: 'organizationCode',
        width: 100,
        filterTypes: ['containsStringOr', {type: 'multiSelectStringOrEquals', subtype: 'bulkString'}, 'null'],
    }),
    numberColumn({field: 'rbvMilkKg', width: 95}),
    numberColumn({field: 'rbvFatKg', width: 80}),
    numberColumn({field: 'rbvFatPercentage', width: 80}),
    numberColumn({field: 'rbvProteinKg', width: 120}),
    numberColumn({field: 'rbvProteinPercentage', width: 110}),
    numberColumn({field: 'bvMilkKg', width: 100}),
    numberColumn({field: 'bvMilkKgReliability', width: 120, filterTypes: ['betweenIntegers', 'equalsInteger', 'null']}),
    numberColumn({field: 'milkProductionIndex', width: 100}),
    numberColumn({field: 'bvFatKg', width: 80}),
    decimalColumn({field: 'bvFatPercentage', width: 80, fixedDecimals: 2}),
    numberColumn({field: 'bvProteinKg', width: 115}),
    decimalColumn({field: 'bvProteinPercentage', width: 110, fixedDecimals: 2}),
    numberColumn({field: 'sihIndex', width: 65}),
    numberColumn({field: 'roboticMilkingIndex', width: 65}),
    stringColumn({
        field: 'productionTraitsCode',
        width: 80,
        filterTypes: ['containsStringOr', {type: 'multiSelectStringOrEquals', subtype: 'bulkString'}, 'null'],
    }),
    decimalColumn({field: 'inbreedingCoefficient', width: 100, fixedDecimals: 3, filterTypes: undefined}),
    numberColumn({field: 'rbvSomaticCells', width: 65}),
    stringColumn({
        field: 'exteriorTraitsCode',
        width: 80,
        filterTypes: ['containsString', 'null'],
        customFiltersOnly: true,
    }),
    numberColumn({field: 'exteriorReliability', width: 80}),
    numberColumn({field: 'rbvClinicalMastitis', width: 65}),
    numberColumn({field: 'rbvLimbDisease', width: 65}),
    numberColumn({field: 'rbvFrame', width: 65}),
    numberColumn({field: 'rbvChestWidth', width: 65}),
    numberColumn({field: 'rbvBodyDepth', width: 65}),
    numberColumn({field: 'rbvEdginess', width: 65}),
    numberColumn({field: 'rbvBackAngle', width: 65}),
    numberColumn({field: 'rbvBackWidth', width: 65}),
    numberColumn({field: 'rbvRearPosture', width: 65}),
    numberColumn({field: 'rbvSidePosture', width: 65}),
    numberColumn({field: 'rbvHoovesAngle', width: 65}),
    numberColumn({field: 'rbvForeUdderAttachment', width: 65}),
    numberColumn({field: 'rbvFrontTeatsPlacement', width: 65}),
    numberColumn({field: 'rbvTeatsLength', width: 65}),
    numberColumn({field: 'rbvUdderDepth', width: 65}),
    numberColumn({field: 'rbvRearUdderAttachmentHeight', width: 65}),
    numberColumn({field: 'rbvSuspensoryLigament', width: 65}),
    numberColumn({field: 'rbvRearTeatsPlacement', width: 65}),
    numberColumn({field: 'rbvRearUdderAttachmentWidth', width: 65}),
    numberColumn({field: 'rbvBonesQuality', width: 65}),
    numberColumn({field: 'rbvWalkQuality', width: 65}),
    numberColumn({field: 'rbvFitness', width: 65}),
    numberColumn({field: 'rbvMilkStrength', width: 60}),
    numberColumn({field: 'rbvBodyStructure', width: 60}),
    numberColumn({field: 'rbvExtremities', width: 95}),
    numberColumn({field: 'rbvUdder', width: 85}),
    numberColumn({field: 'rbvOverallCondition', width: 80}),
    numberColumn({field: 'extremitiesIndex', width: 80}),
    numberColumn({field: 'udderIndex', width: 80}),
    numberColumn({field: 'longevityIndex', width: 80}),
    numberColumn({field: 'rbvMothersChildbirthDifficulty', width: 80}),
    numberColumn({field: 'rbvLongevity', width: 85}),
    numberColumn({field: 'rbvHeifersFertility', width: 85}),
    numberColumn({field: 'rbvDaughtersFertility', width: 85}),
    numberColumn({field: 'rbvMilkability', width: 85}),
    numberColumn({field: 'rbvFirstChildbirthDifficulty', width: 85}),
    numberColumn({field: 'rbvAllChildBirthDifficulties', width: 85}),
];
